import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import EfTab from '@elem/ui/ef-tab';
import EfTitle from '@elem/ui/ef-title';
import EfWhatInBox from '@elem/ui/ef-what-in-box';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { imgLocaleA, imgLocaleB, imgLocaleC } from './Imgs';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.WhatInBox');
    const { locale = 'us', pathname } = useRouter();
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    const imgB = imgLocaleB[locale] || imgLocaleB['eu'];
    const imgC = imgLocaleC[locale] || imgLocaleC['eu'];
    // const textImgA = 'https://websiteoss.ecoflow.com/upload/image/1724578776517/dd3.png';
    // const textImgB = 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png';
    const listA1 = [
        {
            title: t('a_item1'),
            pc: imgA.pc,
        },
        {
            title: t('a_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        ...(locale === 'ph'
            ? [
                  {
                      title: t('a_item3'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
                  },
                  {
                      title: t('a_item4'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
                  },
                  {
                      title: t('a_item5'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1724580687382/2.png',
                  },
              ]
            : [
                  {
                      title: t('a_item3'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
                  },
                  {
                      title: t('a_item4'),
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1724580660907/1.png',
                  },
              ]),
    ];
    const listA2 = [
        {
            title: t('b_item1'),
            pc: imgB.pc,
        },
        {
            title: t('b_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('b_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('b_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
        },
        {
            title: t('b_item5'),
            pc:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724580687382/2.png',
        },
    ];
    const listA3 = [
        {
            title: t('c_item1'),
            pc: imgC.pc,
        },
        {
            title: t('c_item2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580226791/2.png',
        },
        {
            title: t('c_item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580282078/3.png',
        },
        {
            title: t('c_item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580369866/usb.png',
        },
        {
            title: t('c_item5'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724580693542/3.png',
        },
    ];
    const [listA, setListA] = useState(listA1);
    const [items, setItems] = useState(
        [
            {
                type: 'listA1',
                title: t('a_tab'),
            },
            {
                type: 'listA2',
                title: t('b_tab'),
            },
            {
                type: 'listA3',
                title: t('c_tab'),
            },
        ].filter(Boolean),
    );
    const [activeItem, setActiveItem] = useState(items[0]);
    const onChange = (item: any) => {
        const type = item.type;
        if (type === 'listA1') {
            setListA(listA1);
        } else if (type === 'listA2') {
            setListA(listA2);
        } else if (type === 'listA3') {
            setListA(listA3);
        }
        setActiveItem(item);
    };
    return (
        <div className={`${styles.TheComp} WhatInBox-type-${activeItem.type}`}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('title')}</EfTitle>
            <EfWhatInBox list={listA} list_name={t('title')} />
            {locale !== 'au' && pathname !== '/river-3-portable-power-station' && (
                <div className="tab-wrapper">
                    <EfTab items={items} onChange={onChange} />
                </div>
            )}
        </div>
    );
}
